import { genCard } from "./card/index";

function cardFactory(option) {
  return genCard(option);
}

export { cardFactory };
